import Vue from 'vue'
import language from '../../../../build/language/index.js'
import { maskThousand } from '../../../utils/numberMasker.js'
import GraficoIdEnum from '../../../enum/graficoId'

const marginTopChart = 50
const lang = language.getCookieByName('language')

const numberFormatterWithDecimal = language.getIntlCurrencyFormatter()
const numberFormatterWithoutDecimal = language.getIntlCurrencyFormatter(0, 2)

function getCharts () {
  const $t = Vue.i18n.translate
  return [
    // ChartTasks
    {
      idChart: GraficoIdEnum.GADGET_TAREFAS,
      chartTitle: $t('estatistica.tarefa.titulo'),
      idChartTemplate: 'GadgetTasks',
      showTaskGadget: true,
      data: {},
      isLoadingData: true
    },

    // ChartConciliationSituationSummary
    {
      isLoadingData: true,
      idChart: GraficoIdEnum.RESUMO_SITUACAO_CONCILIACAO,
      idChartTemplate: 'ChartConciliationSituationSummary',
      chart: {
        type: 'column',
        marginTop: marginTopChart
      },
      chartTitle: $t('estatistica.resumoConciliacao.titulo'),
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      // Array do eixo x
      xAxis: {
        categories: []
      },

      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: $t('dashboard.labels.valorTotal')
        }
      },

      tooltip: {
        formatter: function () {
          return `<b>${this.x}</b><br/>
            ${this.series.name}: ${maskThousand(this.y)} <br/>
            Total: ${maskThousand(this.point.stackTotal)}`
        }
      },

      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      // Array de objetos
      series: [],

      lang: {
        noData: $t('dashboard.labels.resultadoVazio'),
        contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
        downloadJPEG: $t('dashboard.labels.downloadJPEG'),
        downloadCSV: $t('dashboard.labels.downloadCSV'),
        downloadPDF: $t('dashboard.labels.downloadPDF'),
        downloadPNG: $t('dashboard.labels.downloadPNG'),
        downloadSVG: $t('dashboard.labels.downloadSVG'),
        downloadXLS: $t('dashboard.labels.downloadXLS'),
        printChart: $t('dashboard.labels.printChart'),
        viewData: $t('dashboard.labels.viewData')
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030'
        },
        useHTML: true
      },

      exporting: {
        sourceWidth: 1500,
        sourceHeight: 400,
        scale: 1
      }
    },

    // ChartFinancialSummary
    {
      isLoadingData: true,
      idChart: GraficoIdEnum.RESUMO_FINANCEIRO_PLANO_CONCILIACAO,
      idChartTemplate: 'ChartFinancialSummary',
      chart: {
        type: 'column',
        marginTop: marginTopChart
      },
      chartTitle: $t('estatistica.resumoFinanceiro.titulo'),
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      // Array do eixo x
      xAxis: {
        categories: []
      },

      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: $t('dashboard.labels.valorTotal')
        }
      },

      tooltip: {
        formatter: function () {
          return `<b>${this.x}</b><br/>
            ${this.series.name}: ${maskThousand(this.y)} <br/>
            Total: ${maskThousand(this.point.stackTotal)}`
        }
      },

      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      // Array de objetos
      series: [],

      lang: {
        noData: $t('dashboard.labels.resultadoVazio'),
        contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
        downloadJPEG: $t('dashboard.labels.downloadJPEG'),
        downloadCSV: $t('dashboard.labels.downloadCSV'),
        downloadPDF: $t('dashboard.labels.downloadPDF'),
        downloadPNG: $t('dashboard.labels.downloadPNG'),
        downloadSVG: $t('dashboard.labels.downloadSVG'),
        downloadXLS: $t('dashboard.labels.downloadXLS'),
        printChart: $t('dashboard.labels.printChart'),
        viewData: $t('dashboard.labels.viewData')
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030'
        },
        useHTML: true
      },

      exporting: {
        sourceWidth: 1500,
        sourceHeight: 400,
        scale: 1
      }
    },

    // AllotmentDistributionConciliation
    {
      isLoadingData: true,
      idChart: GraficoIdEnum.DISTRIBUICAO_CONCILIACAO_LOTE,
      idChartTemplate: 'ChartAllotmentDistributionConciliation',
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        marginTop: marginTopChart
      },
      chartTitle: $t('estatistica.conciliacaoLote.titulo'),
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      tooltip: {
        formatter: function () {
          return `
            <b>${this.point.percentage.toFixed(1)}% ${this.point.name}</b><br/>
            ${this.series.name}: ${maskThousand(this.y)}`
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          },
          showInLegend: true
        }
      },
      series: [],
      lang: {
        noData: $t('dashboard.labels.resultadoVazio'),
        contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
        downloadJPEG: $t('dashboard.labels.downloadJPEG'),
        downloadCSV: $t('dashboard.labels.downloadCSV'),
        downloadPDF: $t('dashboard.labels.downloadPDF'),
        downloadPNG: $t('dashboard.labels.downloadPNG'),
        downloadSVG: $t('dashboard.labels.downloadSVG'),
        downloadXLS: $t('dashboard.labels.downloadXLS'),
        printChart: $t('dashboard.labels.printChart'),
        viewData: $t('dashboard.labels.viewData')
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030'
        },
        useHTML: true
      },

      exporting: {
        sourceWidth: 1500,
        sourceHeight: 400,
        scale: 1
      }
    },

    // DailyBankStatment
    {
      isLoadingData: true,
      idChart: GraficoIdEnum.SALDO_BANCARIO,
      idChartTemplate: 'DailyBankStatment',
      chart: {
        type: 'line',
        marginTop: marginTopChart
      },
      chartTitle: $t('estatistica.saldoBancario.titulo'),
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },

      // Array do eixo x
      xAxis: {
        className: 'bold',
        categories: []
      },

      yAxis: {
        allowDecimals: false,
        title: {
          text: $t('dashboard.labels.valorTotal')
        },
        labels: {
          /**
           * Formata o valor do eixo Y com moeda e caso seja maior ou igual a 10000,
           * formata sem casas decimais e concatena o símbolo da ordem de magnitude de
           * acordo com o idioma do usuário logado. @see [BK-1126](https://equals.atlassian.net/browse/BK-1126)
           *
           * Alguns possíveis casos são:
           * 1. Todos os valores do eixo são menores que 100.000;
           * 2. Alguns valores são menores que 100.000;
           * 3. Alguns valores são maiores que 100.000, porém, o intervalo entre eles são menores que a quantidade de pontos no eixo vezes 100;
           * 4. Todos os valores são maiores que 100.000, porém, de mesma ordem de magnitude;
           * 5. Os valores possuem são de ordens de magnitudes diferentes.
           *
           * Exemplos:
           *
           * ```
           *
           *  Caso 1:
           *            |         R$ 10.000
           *  R$ 10.000 |             o
           *            |            /
           *            |           /
           *            |          /
           *            |    R$ 9.000
           *  R$ 9.000  |       o
           *            |      /
           *            |     /
           *            |    /
           *            |R$ 8.000
           *  R$ 8.000  |-o
           *            |
           *            +--------------
           *              |     |     |
           *            01/01 02/01 03/01
           *
           *  Caso 2:
           *            |         R$ 120.000
           *  R$ 120k   |             o
           *            |            /
           *            |           /
           *            |          /
           *            |    R$ 80.000
           *  R$ 80.000 |       o
           *            |      /
           *            |     /
           *            |    /
           *            |R$ 40.000
           *  R$ 40.000 |-o
           *            |
           *            +--------------
           *              |     |     |
           *            01/01 02/01 03/01
           *
           *  Caso 3:
           *             |          R$ 350.000
           *  R$ 350.000 |             o
           *             |            /
           *             |           /
           *             |          /
           *             |  R$ 349.500
           *  R$ 349.500 |       o
           *             |      /
           *             |     /
           *             |    /
           *             |R$ 349.000
           *  R$ 349.000 |-o
           *             |
           *             +--------------
           *               |     |     |
           *             01/01 02/01 03/01
           *
           * Caso 4:
           *           |          R$ 1.250.000
           *  R$ 1,25m |             o
           *           |            /
           *           |           /
           *           |          /
           *           |  R$ 1.225.000
           *  R$ 1,22m |       o
           *           |      /
           *           |     /
           *           |    /
           *           |R$ 1.200.000
           *  R$ 1,2m  |-o
           *           |
           *           +--------------
           *             |     |     |
           *           01/01 02/01 03/01
           *
           * Caso 5:
           *          |      R$ 1.000.000.000
           *  R$ 1bi  |             o
           *          |            /
           *          |           /
           *          |          /
           *          | R$ 500.000.000
           *  R$ 500m |       o
           *          |      /
           *          |     /
           *          |    /
           *          |R$ 1.000.000
           *  R$ 1m   |-o
           *          |
           *          +--------------
           *            |     |     |
           *          01/01 02/01 03/01
           * ```
           */
          formatter: function () {
            // Valor maior ou igual a 100.000
            if (this.value <= -1e5 || this.value >= 1e5) {
              // Se o valor for único no gráfico, retorna o valor completo (com casas decimais e sem o 'k').
              if (this.axis.max - this.axis.min === 0) {
                return numberFormatterWithDecimal(this.value)
              }

              const value = Math.floor(this.value).toString()
              const ticks = this.axis.tickPositions

              // Se o intervalo de um ponto do eixo Y para o
              // próximo ponto for menor que a quantidade de pontos no eixo
              // na ordem das centenas (pois tem 3 digitos),
              // então formata o número sem realizar verificações adicionais.
              if (this.axis.tickInterval < ticks.length * 1e2) {
                return numberFormatterWithoutDecimal(this.value)
              }

              // O máximo de dígitos será o tamanho do número mod 3 (pois é aumentado a ordem de magnitude a cada 3 dígitos)
              // Exemplos: 1.000 (milhar), 10.000 (milhar), 123.456 (milhar), 9.999.999 (milhão), 555.555.555.555 (bilhão), etc.
              const maxDigits = value.length % 3 || 3
              let slicedValue = value.substring(0, maxDigits)

              const abbreviation = language.getMonetaryAbbreviation(this.value, lang)

              // Index do primeiro dígito diferente.
              let earliestIndexDifferentDigit = Number.MAX_SAFE_INTEGER

              for (const tick of ticks) {
                if (tick === value) {
                  continue
                }

                const tickValue = tick.toString()

                // Se o comprimento do valor atual do eixo Y for diferente do valor sendo verificado na lista de valores do eixo Y,
                // então não deve realizar as comparações pois os dígitos que serão cortados serão diferentes ou
                // possivelmente são ordens de magnitude diferentes.
                if (value.length !== tickValue.length) {
                  continue
                }

                const tickAbbreviation = language.getMonetaryAbbreviation(tick, lang)

                const slicedTick = tickValue.substring(0, maxDigits)

                /**
                 * Se os dois valores comparados são iguais quando concatenados com suas ordens de magnitudes.
                 * Exemplo:
                 * Valor 1 = 1500000
                 * Valor 2 = 1750000
                 * Ou seja, os dois valores quando cortados serão iguais a "1" e suas ordens de magnitudes serão "m", logo serão "1m" = "1m".
                 */
                if (slicedTick + tickAbbreviation === slicedValue + abbreviation) {
                  /**
                   * Itera por cada dígito buscando o index do primeiro dígito diferente.
                   * Exemplo:
                   * Valor 1 = 1553233
                   * Valor 2 = 1543233
                   * O index do primeiro diferente dígito será "2", neste caso, o dígito "4".
                   */
                  for (let digitIndex = 0; digitIndex < value.length; ++digitIndex) {
                    if (value[digitIndex] !== tickValue[digitIndex] && digitIndex < earliestIndexDifferentDigit) {
                      // Adicionando 1 para compensar pois queremos o próximo dígito (o primeiro diferente).
                      earliestIndexDifferentDigit = digitIndex + 1
                      break
                    }
                  }
                }
              }

              let numberFormatter = numberFormatterWithoutDecimal
              if (earliestIndexDifferentDigit !== Number.MAX_SAFE_INTEGER) {
                // Mais 1 para compensar pelo index (que começa em 0).
                earliestIndexDifferentDigit++
                slicedValue += '.' + value.substring(slicedValue.length, earliestIndexDifferentDigit)
                if (earliestIndexDifferentDigit !== 2) {
                  // Cria um formatador novo pois queremos mostrar os números decimais que sejam do tamanho necessário para diferenciar.
                  numberFormatter = language.getIntlCurrencyFormatter(0, earliestIndexDifferentDigit)
                }
              }

              return numberFormatter(slicedValue) + abbreviation
            }
            return numberFormatterWithoutDecimal(this.value)
          }
        }
      },

      tooltip: {
        formatter: function () {
          return `<b>${this.x}</b><br/>
            ${this.series.name}: ${maskThousand(this.y)}`
        }
      },

      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            /**
             * Formatador de valores para cada linha do eixo X do gŕafico. @see [BK-1126](https://equals.atlassian.net/browse/BK-1126)
             *
             * Os casos são:
             * 1. Se para todos os pontos do eixo X o valor for o mesmo, então, o gráfico irá mostrar o valor no eixo Y sem labels para cada ponto do eixo X.
             * 2. Se para uma sequência de valores do eixo X o valor for o mesmo, então, será mostrado label no primeiro valor diferente.
             * 3. Se todos os valores forem diferentes, então, será mostrado cada valor individual.
             *
             * Exemplos:
             *
             * ```
             *  Caso 1:
             *           |
             *           |
             *           |
             *  R$ 1,00  |-o-----o-----o-----o
             *           |
             *           |
             *           +----------------------
             *             |     |     |     |
             *           01/01 02/01 03/01 04/01
             *
             *  Caso 2:
             *           |         R$ 10,00
             *  R$ 10,00 |             o------o
             *           |            /
             *           |           /
             *  R$ 5,00  |          /
             *           |         /
             *           |R$1,00  /
             *  R$ 1,00  |-o-----o
             *           |
             *           +----------------------
             *             |     |     |     |
             *           01/01 02/01 03/01 04/01
             *
             * Caso 3:
             *           |   R$ 10,00    R$ 10,00
             *  R$ 10,00 |       o           o
             *           |      / \         /
             *           |     /   \       /
             *  R$ 5,00  |    /     \     /
             *           |   /       \   /
             *           |R$1,00    R$1,00
             *  R$ 1,00  |-o           o
             *           |
             *           +----------------------
             *             |     |     |     |
             *           01/01 02/01 03/01 04/01
             * ```
             */
            formatter: function () {
              const index = this.point.index
              let isEveryItemEqual = false
              // Se estivermos formatando o primeiro número, verificamos se todos os números são iguais.
              if (index === 0) {
                isEveryItemEqual = this.series.yData.every(y => y === this.y)
              }

              // Se todos os números forem iguais ou o número anterior for igual ao atual, não mostra o valor.
              if (isEveryItemEqual || (index > 0 && this.y === this.series.yData[index - 1])) {
                return null
              }

              // Formata o número adicionando moeda e pontuação.
              return numberFormatterWithDecimal(this.y)
            },
            y: -10
          },
          enableMouseTracking: true
        }
      },
      // Array de objetos
      series: [],
      lang: {
        noData: $t('dashboard.labels.resultadoVazio'),
        contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
        downloadJPEG: $t('dashboard.labels.downloadJPEG'),
        downloadCSV: $t('dashboard.labels.downloadCSV'),
        downloadPDF: $t('dashboard.labels.downloadPDF'),
        downloadPNG: $t('dashboard.labels.downloadPNG'),
        downloadSVG: $t('dashboard.labels.downloadSVG'),
        downloadXLS: $t('dashboard.labels.downloadXLS'),
        printChart: $t('dashboard.labels.printChart'),
        viewData: $t('dashboard.labels.viewData')
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030'
        },
        useHTML: true
      },

      exporting: {
        sourceWidth: 1720,
        sourceHeight: 400,
        scale: 1
      }
    },

    // DigitalWalletBalance
    {
      isLoadingData: true,
      idChart: GraficoIdEnum.SALDO_CARTEIRA_DIGITAL,
      idChartTemplate: 'DigitalWalletBalance',
      chart: {
        type: 'line',
        marginTop: marginTopChart
      },
      chartTitle: $t('estatistica.saldoCarteiraDigital.titulo'),
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },

      // Array do eixo x
      xAxis: {
        className: 'bold',
        categories: []
      },

      yAxis: {
        allowDecimals: false,
        title: {
          text: $t('dashboard.labels.valorTotal')
        },
        labels: {
          formatter: function () {
            // Valor maior ou igual a 100.000
            if (this.value <= -1e5 || this.value >= 1e5) {
              // Se o valor for único no gráfico, retorna o valor completo (com casas decimais e sem o 'k').
              if (this.axis.max - this.axis.min === 0) {
                return numberFormatterWithDecimal(this.value)
              }

              const value = Math.floor(this.value).toString()
              const ticks = this.axis.tickPositions

              // Se o intervalo de um ponto do eixo Y para o
              // próximo ponto for menor que a quantidade de pontos no eixo
              // na ordem das centenas (pois tem 3 digitos),
              // então formata o número sem realizar verificações adicionais.
              if (this.axis.tickInterval < ticks.length * 1e2) {
                return numberFormatterWithoutDecimal(this.value)
              }

              // O máximo de dígitos será o tamanho do número mod 3 (pois é aumentado a ordem de magnitude a cada 3 dígitos)
              // Exemplos: 1.000 (milhar), 10.000 (milhar), 123.456 (milhar), 9.999.999 (milhão), 555.555.555.555 (bilhão), etc.
              const maxDigits = value.length % 3 || 3
              let slicedValue = value.substring(0, maxDigits)

              const abbreviation = language.getMonetaryAbbreviation(this.value, lang)

              // Index do primeiro dígito diferente.
              let earliestIndexDifferentDigit = Number.MAX_SAFE_INTEGER

              for (const tick of ticks) {
                if (tick === value) {
                  continue
                }

                const tickValue = tick.toString()

                // Se o comprimento do valor atual do eixo Y for diferente do valor sendo verificado na lista de valores do eixo Y,
                // então não deve realizar as comparações pois os dígitos que serão cortados serão diferentes ou
                // possivelmente são ordens de magnitude diferentes.
                if (value.length !== tickValue.length) {
                  continue
                }

                const tickAbbreviation = language.getMonetaryAbbreviation(tick, lang)

                const slicedTick = tickValue.substring(0, maxDigits)

                /**
                 * Se os dois valores comparados são iguais quando concatenados com suas ordens de magnitudes.
                 * Exemplo:
                 * Valor 1 = 1500000
                 * Valor 2 = 1750000
                 * Ou seja, os dois valores quando cortados serão iguais a "1" e suas ordens de magnitudes serão "m", logo serão "1m" = "1m".
                 */
                if (slicedTick + tickAbbreviation === slicedValue + abbreviation) {
                  /**
                   * Itera por cada dígito buscando o index do primeiro dígito diferente.
                   * Exemplo:
                   * Valor 1 = 1553233
                   * Valor 2 = 1543233
                   * O index do primeiro diferente dígito será "2", neste caso, o dígito "4".
                   */
                  for (let digitIndex = 0; digitIndex < value.length; ++digitIndex) {
                    if (value[digitIndex] !== tickValue[digitIndex] && digitIndex < earliestIndexDifferentDigit) {
                      // Adicionando 1 para compensar pois queremos o próximo dígito (o primeiro diferente).
                      earliestIndexDifferentDigit = digitIndex + 1
                      break
                    }
                  }
                }
              }

              let numberFormatter = numberFormatterWithoutDecimal
              if (earliestIndexDifferentDigit !== Number.MAX_SAFE_INTEGER) {
                // Mais 1 para compensar pelo index (que começa em 0).
                earliestIndexDifferentDigit++
                slicedValue += '.' + value.substring(slicedValue.length, earliestIndexDifferentDigit)
                if (earliestIndexDifferentDigit !== 2) {
                  // Cria um formatador novo pois queremos mostrar os números decimais que sejam do tamanho necessário para diferenciar.
                  numberFormatter = language.getIntlCurrencyFormatter(0, earliestIndexDifferentDigit)
                }
              }

              return numberFormatter(slicedValue) + abbreviation
            }
            return numberFormatterWithoutDecimal(this.value)
          }
        }
      },

      tooltip: {
        formatter: function () {
          return `<b>${this.x}</b><br/>
            ${this.series.name}: ${maskThousand(this.y)}`
        }
      },

      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              const index = this.point.index
              let isEveryItemEqual = false
              // Se estivermos formatando o primeiro número, verificamos se todos os números são iguais.
              if (index === 0) {
                isEveryItemEqual = this.series.yData.every(y => y === this.y)
              }

              // Se todos os números forem iguais ou o número anterior for igual ao atual, não mostra o valor.
              if (isEveryItemEqual || (index > 0 && this.y === this.series.yData[index - 1])) {
                return null
              }

              // Formata o número adicionando moeda e pontuação.
              return numberFormatterWithDecimal(this.y)
            },
            y: -10
          },
          enableMouseTracking: true
        }
      },
      // Array de objetos
      series: [],
      lang: {
        noData: $t('dashboard.labels.resultadoVazio'),
        contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
        downloadJPEG: $t('dashboard.labels.downloadJPEG'),
        downloadCSV: $t('dashboard.labels.downloadCSV'),
        downloadPDF: $t('dashboard.labels.downloadPDF'),
        downloadPNG: $t('dashboard.labels.downloadPNG'),
        downloadSVG: $t('dashboard.labels.downloadSVG'),
        downloadXLS: $t('dashboard.labels.downloadXLS'),
        printChart: $t('dashboard.labels.printChart'),
        viewData: $t('dashboard.labels.viewData')
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030'
        },
        useHTML: true
      },

      exporting: {
        sourceWidth: 1720,
        sourceHeight: 400,
        scale: 1
      }
    }
  ]
}

export { getCharts }



// WEBPACK FOOTER //
// ./client/components/views/index/config.js